import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { api, errMsg } from "@/lib/api";

export const useOtp = (sendUrl, onConfirm) => {
  const [otp, setOtp] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const ask = async (action) => {
    setBusy(true);
    try {
      const { data } = await api.post(sendUrl, { action });
      setCode("");
      setOtp({ action, ...data });
      toast.success(`Code sent to ${data.sent_to}`);
    } catch (e) { toast.error(errMsg(e, "Could not send the code")); } finally { setBusy(false); }
  };
  const confirm = async () => {
    setBusy(true);
    const ok = await onConfirm(otp, code);
    setBusy(false);
    if (ok) setOtp(null); else setCode("");
  };
  return { otp, setOtp, code, setCode, busy, ask, confirm };
};

export default function OtpDialog({ o, title, testid = "settings-otp" }) {
  return (
    <Dialog open={!!o.otp} onOpenChange={(v) => !v && o.setOtp(null)}>
      <DialogContent className="bg-[#121214] border-zinc-800 text-zinc-100 max-w-sm" data-testid={`${testid}-dialog`}>
        <DialogHeader><DialogTitle className="font-heading">{title}</DialogTitle></DialogHeader>
        <p className="text-sm text-zinc-400">Enter the 6-digit code sent to <b className="text-white">{o.otp?.sent_to}</b>. It expires in 10 minutes.</p>
        <div className="flex justify-center py-2">
          <InputOTP maxLength={6} value={o.code} onChange={o.setCode} data-testid={`${testid}-input`}>
            <InputOTPGroup>{[0, 1, 2, 3, 4, 5].map((i) => <InputOTPSlot key={i} index={i} className="border-zinc-700 bg-[#0A0A0A]" />)}</InputOTPGroup>
          </InputOTP>
        </div>
        <div className="flex gap-2">
          <button onClick={() => o.ask(o.otp.action)} disabled={o.busy} className="ax-chip flex-1 justify-center" data-testid={`${testid}-resend`}>Resend code</button>
          <button onClick={o.confirm} disabled={o.code.length !== 6 || o.busy} className="ax-generate flex-1" data-testid={`${testid}-confirm`}>
            {o.busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Confirm"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
